import faMessages from '../locales/fa-ir.json';

const FaLang = {
  messages: {
    ...faMessages,
  },
  locale: 'fa-IR',
};
export default FaLang;
